import RegionCard from './RegionCard';

export default RegionCard;



// WEBPACK FOOTER //
// ./src/components/RegionCard/index.ts